import { CoreApi, ErrorMessages, ProductInfoComponent } from '@inter-ikea-storageone/range';
import { ComponentIds, Entity, MeasurementUtils } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';
import { Vector } from '@inter-ikea-core/core';
import { enableDarkModeIfLightsInScene } from 'rangeConfig/shared/utils/darkMode';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const autoFillLights = ({
  coreApi,
  rootState: {
    products: { selectedGroupId },
    layout: { darkScene }
  },
  props
}: BehaviorParameters) => {
  const productId =
    props.coreProductIds && props.coreProductIds.length > 0
      ? props.coreProductIds[0]
      : props.coreProductId;
  const oldLights = coreApi.entities.getByComponent(ComponentIds.LIGHT_COMPONENT_ID);
  const clothRails = coreApi.entities.getByProductTypes([
    ProductType.PLATSA_CLOTH_RAIL_55,
    ProductType.PLATSA_CLOTH_RAIL_55_W_HOOKS_ASM
  ]);
  const clothRailPosition = [
    ...getEntitiesAbove(clothRails, coreApi),
    ...coreApi.entities.getByProductType(ProductType.PLATSA_OPEN_FRAME_HANGING)
  ];

  const targets =
    clothRailPosition.length > 0
      ? clothRailPosition
      : coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);

  const placementResults = coreApi.products.autoFillInnerLights(productId, targets, oldLights);

  const determinePlacementAttemptErrorMessage = () => {
    const clothRailCollision = placementResults
      .map(placementResult =>
        placementResult.errors.flatMap((error: any) => {
          return error?.collisions?.find((c: { other: Entity }) => {
            const collisionType = c.other.getComponent<ProductInfoComponent>(
              ProductInfoComponent.id
            )?.productType;
            return collisionType === ProductType.PLATSA_CLOTH_RAIL_40;
          });
        })
      )
      .flat()
      ?.filter(c => c !== undefined);

    if (!hideNoFramesInSceneErrorMessage(coreApi)) {
      return ErrorMessages.NoFramesInScene;
    } else if (clothRailCollision.length > 0) {
      return ErrorMessages.PlatsaClothRailCollision;
    }
    return null;
  };
  const placementAttemptErrorMessage = determinePlacementAttemptErrorMessage();
  if (placementAttemptErrorMessage) {
    coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
  }

  enableDarkModeIfLightsInScene(coreApi, darkScene, selectedGroupId);
};

export const getEntitiesAbove = (targets: Entity[], coreApi: CoreApi) => {
  const entities: Entity[] = [];

  const directionToTop = new Vector(0, 1, 0);

  targets.forEach(target => {
    const targetParent = coreApi.entities.getParent(target);
    if (targetParent) {
      const measurement = MeasurementUtils.getInsideMeasurementLocalSpace(
        target,
        targetParent,
        directionToTop
      );
      if (measurement) {
        entities.push(measurement.end.entity);
      }
    }
  });
  return entities;
};

export default autoFillLights;
